const articles = [
    {
      id: 1,
      title: "Invest in Quality Cold Weather Gear",
      description: "To thrive in Toronto's harsh winters, it's important to invest in practical, high-quality winter gear. Stay active to support physical and mental health, with options like U of T's sports and fitness activities. Be mindful of mental health during the long, dark days—staying active, getting enough sunlight, and seeking support can help. Despite the cold, Toronto offers opportunities to embrace winter through activities like ice skating, tobogganing, and festive events.",
      link: "https://drive.google.com/file/d/1-4MagaNyUgXXxYtKJdSMMOBC0igy5R6j/view?usp=sharing",
      image: "imgs/article_imgs/article1alt.jpg"
    },
    /*{
      id: 2,
      title: "Skule Courses",
      description: "The Skule Courses website managed by the University of Toronto Engineering Society. An archive of U of T Engineering courses, with past midterms, exams, notes, syllabi, and more.",
      link: "https://courses.skule.ca/",
      image: "imgs/event_icons/UofTECE.png"
    }*/
];

export default articles;